"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _ActionMessage = _interopRequireDefault(require("01_core/components/materials/ActionMessage"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _APIs = require("01_core/constants/APIs");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _CardContent = _interopRequireDefault(require("@mui/material/CardContent"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _styles = require("@mui/material/styles");
var _kansaReportActions = require("../kansaReportActions");
var _KansaReportEvaluationHeader = _interopRequireDefault(require("./components/KansaReportEvaluationHeader"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const WhiteSpaceTypography = (0, _styles.styled)(_Typography.default)(_ref => {
  let {
    theme
  } = _ref;
  return {
    whiteSpace: 'pre-line',
    fontSize: theme.typography.body2.fontSize
  };
});

/**
 * 監査報告書評価表示画面
 */
class KansaReportEvaluationRefer extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "getEntries", () => {
      const {
        callAPI,
        targetReport,
        setEntries
      } = this.props;
      const {
        kaishaSummary,
        kansaTgtNendo,
        hikansabumonKaishaCd,
        hikansabumonSoshikiCd
      } = targetReport;
      callAPI(_APIs.KANSA_REPORT_EV_REFER, {
        kaishaSummary,
        kansaTgtNendo,
        hikansabumonKaishaCd,
        hikansabumonSoshikiCd,
        editable: false
      }).then(response => {
        if (response.status === _APIs.STATUS.SUCCESS) {
          setEntries(response.data);
        }
      });
    });
    _defineProperty(this, "onChange", key => value => this.props.changeEntry(key, value));
    this.getEntries();
  }
  componentWillUnmount() {
    const {
      clearEntries
    } = this.props;
    clearEntries();
  }
  render() {
    const {
      intl,
      entries,
      goMain,
      dispContent,
      previousContent,
      openReport,
      info
    } = this.props;
    const {
      kinyuDate,
      kinyushaNm,
      comment
    } = entries;
    const showResult = previousContent === _kansaReportActions.CONTENTS.EV_REGISTER;
    const returnBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      key: "return",
      negative: true,
      autoWidth: true,
      onClick: () => {
        goMain(dispContent);
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_SEARCH_LIST
    }));
    const openReportBtn = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      key: "openReport",
      autoWidth: true,
      onClick: openReport
    }, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_SHOW_REPORT
    }));
    return info.ready ? /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: showResult ? _labelConsts.LABEL.KANSA_REPORT_EVALUATION_REGISTER_RESULT : _labelConsts.LABEL.KANSA_REPORT_EVALUATION_REFER
      }),
      actions: [returnBtn],
      fixedWidth: true
    }, /*#__PURE__*/_react.default.createElement(_CardContent.default, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, !entries ? /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, null, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_NO_DATA_TO_DISPLAY
    }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      },
      align: "right"
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, openReportBtn, _stringConsts.STRING_CONSTS.FULL_SPACE, returnBtn)), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
      container: true,
      spacing: 1
    }, showResult && /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_ActionMessage.default, {
      action: "register"
    })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_KansaReportEvaluationHeader.default, {
      entries: entries
    })))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYU_DATE
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(kinyuDate)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_KINYUSHA
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
      variant: "body2"
    }, _stringUtil.default.emptyToHyphen(kinyushaNm)))), /*#__PURE__*/_react.default.createElement(_Grid.default, {
      size: {
        xs: 12
      }
    }, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
      label: intl.formatMessage({
        id: _labelConsts.LABEL.KANSA_REPORT_EV_COMMENT
      }),
      indent: true
    }, /*#__PURE__*/_react.default.createElement(WhiteSpaceTypography, null, _stringUtil.default.emptyToHyphen(comment)))))))) : null;
  }
}
const mapStateToProps = state => {
  return {
    dispContent: state.kansaReport.containerInfo.dispContent,
    previousContent: state.kansaReport.containerInfo.previousContent,
    targetReport: state.kansaReport.targetReport,
    info: state.kansaReport.evaluation,
    entries: state.kansaReport.evaluation.entries
  };
};
const mapDispatchToProps = dispatch => {
  return {
    setEntries: entries => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_EV_ENTRIES](entries)),
    changeEntry: (key, value) => {
      dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_EV_ENTRY](key, value));
    },
    openInfoBar: (type, message) => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    goMain: previousContent => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.GO_MAIN](previousContent)),
    clearEntries: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CLEAR_EV_ENTRIES]())
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaReportEvaluationRefer)));